// This file is auto-generated by ./bin/rails stimulus:manifest:update
// Run that command whenever you add a new controller or create them with
// ./bin/rails generate stimulus controllerName

import { application } from "./application"

import NavController from "./nav_controller"
application.register("nav", NavController)

import ScrollToController from "./scroll_to_controller"
application.register("scroll-to", ScrollToController)

import SwiperController from "./swiper_controller"
application.register("swiper", SwiperController)
